import Spinner from "../Spinner";
import "./GenericLoader.css";

const GenericLoader = () => {
  return (
    <div className="global-loader-overlay">
        <div className="global-content-container">
          <Spinner />
        </div>
      </div>
  );
};

export default GenericLoader;
